import { BaseNode } from "./base-node";

export interface LoopBackgroundNodeParams {
	mediaId: string;
	url: string;
	file: File;
	mediaType: "image" | "video";
	/** The loop asset's OWN natural duration, in ticks — used to wrap playback time for seamless
	 * repeat once the scene plays longer than one loop cycle (see resolve.ts's
	 * resolveLoopBackgroundNode). Ignored for images. */
	durationTicks?: number;
}

export interface ResolvedLoopBackgroundNodeState {
	source: CanvasImageSource;
	width: number;
	height: number;
}

/**
 * A looping, full-canvas-covering decorative layer — project-level (comes from
 * TProjectSettings.loop, not a movable/deletable timeline clip), drawn right after the
 * background node and before every track's own content (see scene-builder.ts). Sibling to
 * BackgroundImageNode, but unlike it, the video variant genuinely varies frame to frame (a
 * static background image never does), which is why it carries mediaId/file/durationTicks the
 * way VideoNode does instead of BackgroundImageNode's bare `url`.
 *
 * Always silent by design — this is a decorative visual loop (e.g. particles, VHS noise, an
 * ambient clip), not a content video with its own audio; the timeline's real audio mix never
 * reads from this node at all.
 */
export class LoopBackgroundNode extends BaseNode<
	LoopBackgroundNodeParams,
	ResolvedLoopBackgroundNodeState
> {}
